import LockIcon from "@ch/assets/icons/pack/LockIcon";
import Button from "@ch/components/Buttons/Button";
import Modal from "@ch/components/Modals/Modal";
import delay from "@ch/helpers/utils/delay";
import { type FC, useEffect } from "react";

export const KEM_UPGRADE_NOTICE_MODAL_ID = "upgrade-notice-modal";

export interface KemUpgradeNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubscribe: () => void;
}

const closeDialogue = () => {
  const dialogue = document.getElementById(
    KEM_UPGRADE_NOTICE_MODAL_ID,
  ) as HTMLDialogElement | null;

  dialogue?.close();
};

const KemUpgradeNoticeModal: FC<KemUpgradeNoticeModalProps> = ({
  isOpen,
  onClose,
  onSubscribe,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    let cancelled = false;

    void (async () => {
      await delay(100);
      if (cancelled) {
        return;
      }

      const dialogue = document.getElementById(
        KEM_UPGRADE_NOTICE_MODAL_ID,
      ) as HTMLDialogElement | null;

      if (!dialogue || dialogue.open) {
        return;
      }

      dialogue.showModal();
    })();

    return () => {
      cancelled = true;
      closeDialogue();
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleClose = () => {
    closeDialogue();
    onClose();
  };

  const handleSubscribe = () => {
    closeDialogue();
    onSubscribe();
  };

  return (
    <Modal
      closeOnClickESC={false}
      closeOnClickOutside={false}
      footerComponent={
        <div className="flex w-full flex-col gap-3">
          <Button className="w-full" onClick={handleSubscribe} type="button">
            Subscribe
          </Button>
          <Button
            className="w-full"
            intent="outline"
            onClick={handleClose}
            type="button"
            variant="secondary"
          >
            Maybe Later
          </Button>
        </div>
      }
      isModalOpen
      modalBoxClassName="md:w-[480px] !h-fit"
      modalId={KEM_UPGRADE_NOTICE_MODAL_ID}
      onDismiss={handleClose}
      showCloseIcon={false}
    >
      <div className="flex flex-col items-center px-2 py-4 text-center">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#FD6E5E]">
          <LockIcon />
        </div>
        <h2 className="mb-2 text-lg font-semibold text-[#101828]">
          You&apos;ve used all your free Kem messages
        </h2>
        <p className="mb-2 text-base text-[#6A7282]">
          Subscribe to continue chatting with Kem.
        </p>
      </div>
    </Modal>
  );
};

export default KemUpgradeNoticeModal;
